// role="img" is deliberate: none of this site's diagrams embed links or
// other interactive children (confirmed against built output — mermaid
// CAN emit clickable <a> nodes). Revisit if a future diagram needs one.

const humanizeDiagramType = (raw: string | null): string => {
  const type = (raw || "").toLowerCase()
  if (type.startsWith("flowchart")) return "flowchart diagram"
  if (type.startsWith("sequence")) return "sequence diagram"
  if (type.startsWith("class")) return "class diagram"
  if (type.startsWith("state")) return "state diagram"
  if (type.startsWith("er")) return "entity relationship diagram"
  if (type.startsWith("gantt")) return "Gantt chart"
  if (type.startsWith("pie")) return "pie chart"
  if (type.startsWith("journey")) return "user journey diagram"
  if (type.startsWith("git")) return "git graph diagram"
  return type ? `${type} diagram` : "diagram"
}

const HEADINGS_SELECTOR = "h1, h2, h3, h4, h5, h6"

const nearestPrecedingHeadingText = (el: Element, headings: Element[]): string | null => {
  let best: Element | null = null
  for (const heading of headings) {
    // DOCUMENT_POSITION_FOLLOWING on (heading, el) means heading precedes el;
    // headings is in document order, so once that stops holding we can break.
    if (heading.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) {
      best = heading
    } else {
      break
    }
  }
  return best?.textContent?.trim() || null
}

export const refreshMermaidAccessibility = (): void => {
  if (typeof document === "undefined") return
  const svgs = document.querySelectorAll<SVGSVGElement>("svg[aria-roledescription]")
  if (svgs.length === 0) return

  const headings = Array.from(document.querySelectorAll(HEADINGS_SELECTOR))

  svgs.forEach(svg => {
    const diagramLabel = humanizeDiagramType(svg.getAttribute("aria-roledescription"))
    const heading = nearestPrecedingHeadingText(svg, headings)

    svg.setAttribute("role", "img")
    svg.setAttribute("aria-roledescription", diagramLabel)
    svg.setAttribute("aria-label", heading ? heading : "Diagram")
  })
}
